import { fetchWithAuthHeader } from '../../auth';
import { jsonResponseHandling } from '../fetch';
import { apiUrl, TRAFFIC_PATH } from '../api-manager';

export const fetchIncidents = async () => fetchWithAuthHeader(
    apiUrl(`${TRAFFIC_PATH}/traffic/incidents`),
    {
        method: 'GET',
    },
).then(response => jsonResponseHandling(response));
